import { localizationUtils } from '../../../../shared/utils';

import OrderSummary from './OrderSummary';

import resources from './locales';

const { withLocalization } = localizationUtils;

export default withLocalization(OrderSummary, resources, 'OrderSummary');
